import { useEffect, useState } from "react";
import { Modal, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import _ from "lodash";
import { getSignedUploadUrl, updateBrickCollection } from "../../utils";
import useOrganization from "../../hooks/useOrganization";

const getKey = (organization: string, collection: string, file: any) =>
  `${organization}/${collection}/brick_${file.uid}.${file.name.split(".").pop() ?? 'jpg'}`;

interface Props {
  brickCollection: any | null;
  open: boolean;
  onClose(): void;
}

const UploadBricksModal: React.FC<Props> = ({
  brickCollection,
  open,
  onClose,
}) => {
  const organization = useOrganization();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [fileList, setFileList] = useState<any[]>([]);

  useEffect(() => {
    setSubmitting(false);
  }, [open]);

  const handleFileChanged = ({ fileList }: { fileList: any[] }) => {
    setFileList(fileList);
  };

  // Custom xhr upload method
  const handleUpload = async ({
    onSuccess,
    onError,
    onProgress,
    file,
  }: any) => {
    const key = `${organization}/${brickCollection._id}/brick_${file.uid}.${file.name.split(".").pop() ?? 'jpg'}`;
    const { [key]: signedUrlData } = await getSignedUploadUrl([
      { name: key, contentType: file.type },
    ]);

    const fmData = new FormData();
    Object.keys(signedUrlData.fields).forEach((key) =>
      fmData.append(key, signedUrlData.fields[key])
    );
    fmData.append("file", file);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", signedUrlData.url);
    xhr.onreadystatechange = async () => {
      console.log("done");
      console.log(xhr);
      if (xhr.readyState === 4) {
        if (xhr.status === 204) {
          console.log("success");
          onSuccess(null, file);
        } else {
          console.log(xhr.responseText);
          onError(xhr.responseText, xhr.response, file);
        }
      }
    };
    xhr.upload.onprogress = (ev) => {
      console.log(ev);
      onProgress((ev.loaded / ev.total) * 100, file);
    };
    xhr.send(fmData);
  };

  const submitBricks = async () => {
    setSubmitting(true);
    await updateBrickCollection(organization, brickCollection._id, {
      bricks: [
        ...brickCollection.bricks,
        ...fileList.map((file) => ({
          type: "full",
          image: getKey(organization, brickCollection._id, file),
        })),
      ],
    });
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={submitBricks}
      okButtonProps={{
        disabled: submitting || !_.every(fileList, (f) => f.status === "done"),
      }}
      okText="Klaar"
      closable={false}
      destroyOnHidden
    >
      <Upload.Dragger
        accept="image/*"
        listType="picture-card"
        multiple
        showUploadList={{
          showDownloadIcon: false,
          showPreviewIcon: true,
          showRemoveIcon: false,
        }}
        customRequest={(e) => handleUpload(e)}
        onChange={(e) => handleFileChanged(e)}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Klik of sleep een bestand hier om te uploaden
        </p>
      </Upload.Dragger>
    </Modal>
  );
};

export default UploadBricksModal;
